import { createStore, combineReducers } from 'redux';
import { ProjectEditReducer } from './reducers/project_edit';

const reducer = combineReducers({
    projectEdit: ProjectEditReducer
});
export const store = createStore(reducer);
const state = store.getState();
export declare type ReduxState = typeof state;